module.exports = __webpack_public_path__ + "static/media/times-circle-black.e975357a.svg";